<template>
    <div class="horizontal-lock">
        <div class="tabs" :class="{ container: $breakpoints.isGreaterThan('sm') }">
            <q-tabs inverted no-pane-border color="primary" v-model="selectedTab" @select="updateRoute">
              <!--<div class="q-tabs-scroller row no-wrap text-primary lang" :class="langAR">-->
              <template v-for="(tab, label, i) in computedTabs">
                <a class=" q-tabs-align-right" :name="`tab-${label}`"/>
                <q-tab :default="i==0" slot="title" :label="label" :name="`tab-${label}`"/>
              </template>
              <!--</div>-->
                <q-tab-pane :class="textAlign" v-for="(tab, label) in computedTabs" :key="label" :name="`tab-${label}`">
                    <slot :name="`tab-${label}`">
                        <v-row-group v-for="(group, model) in tab.rowGroups" :key="model"
                                     :title="model" :rows="group" :is-video="isVideo"></v-row-group>
                    </slot>
                </q-tab-pane>
            </q-tabs>
        </div>
    </div>
</template>

<script>
    import {
        QTabs,
        QTab,
        QTabPane
    } from 'quasar-framework'
    import {mapGetters} from "vuex";

    export default {
        name: 'VTabs',

        components: {
            QTabs,
            QTab,
            QTabPane
        },
        props: {
            tabs: {
                type: [Array, Object],
                required: true
            },
            all: Boolean,
            isVideo: Boolean,
            boundToRoute: Boolean
        },
        data: () => ({
            selectedTab: null,
            mounted: null,
            lang: window.config.locale.toUpperCase(),
            langAR: '',
            textAlign: '',
        }),
        watch: {
            '$route': 'setActiveTab'
        },
        mounted() {
            this.setActiveTab()
            this.mounted = true
        },
        computed: {
          ...mapGetters({
            locale: 'lang/locale',
            locales: 'lang/locales',
            user: 'auth/user',
          }),
            computedTabs() {
                if (!this.all)
                    return this.tabs
                let allTabs = {
                    all: {
                        rowGroups: {}
                    }
                }
                Object.keys(this.tabs).forEach(tab => {
                    let rowGroups = deepCopy(this.tabs[tab].rowGroups)
                    Object.keys(rowGroups).forEach(g => rowGroups[g].forEach(r => {
                        r.uri = `#tab-${tab}`
                        r.items = r.items.slice(0, 6)
                    }))
                    Object.assign(allTabs.all.rowGroups, rowGroups)
                })
                return Object.assign(allTabs, this.tabs)
            }
        },
        methods: {
            setActiveTab() {
                if (this.$route.hash) {
                    let tab = this.$route.hash.substring(1)
                    if (this.tabs[tab.substring(4)])
                        this.selectedTab = tab
                }
            },
            updateRoute(tab) {
                if (this.$route.hash != `#${tab}` && this.boundToRoute && this.mounted)
                    this.$router.replace({hash: `#${tab}`})
            },
        }
    }
</script>

<style lang="stylus" scoped>
    .lang{
        margin-top -58px
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Tabs.vue